var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 1.714v20.572c0 .454-.18.89-.498 1.212A1.693 1.693 0 013.4 24H1.7c-.45 0-.883-.18-1.202-.502A1.722 1.722 0 010 22.286V1.714C0 1.26.18.824.498.502A1.693 1.693 0 011.7 0h1.7c.45 0 .883.18 1.202.502.319.322.498.758.498 1.212z",
    fill: "#ADC6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.15 0h-1.7C8 0 7.567.18 7.248.502a1.722 1.722 0 00-.498 1.212v20.572c0 .454.18.89.498 1.212.319.321.751.502 1.202.502h1.7c.45 0 .883-.18 1.202-.502.319-.322.498-.758.498-1.212V1.714c0-.454-.18-.89-.498-1.212A1.693 1.693 0 0010.15 0z",
    fill: "#597EF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.642 21.266L18.424 1.397a1.71 1.71 0 00-.785-1.039 1.652 1.652 0 00-1.274-.17l-1.622.446c-.43.119-.797.407-1.019.8a1.744 1.744 0 00-.166 1.3l5.218 19.869c.096.364.308.685.6.915a1.66 1.66 0 001.46.293l1.621-.445c.43-.119.797-.406 1.019-.8.222-.394.282-.861.166-1.3z",
    fill: "#2F54EB"
  })));
}

export default __webpack_public_path__ + "./fonts/library.bcdfa274f60de7bc2859d7bc7e8abeff.svg";
export { SvgLibrary as ReactComponent };